import React from 'react';
import './contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { RiMessengerLine } from 'react-icons/ri';
import { RiLinkedinBoxFill } from "react-icons/ri";
import { useTranslation } from '../../contexts/TranslationContext';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <section id='contact'>
      <h1 className="titrecontact">Contact</h1>
      <h2>{t('contact.subtitle')}</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className='contact__option-icon' />
            <h4>Email</h4>
            <h5>tanguybruschi.son@gmail.com</h5>
            <a href="mailto:tanguybruschi.son@gmail.com" target="_blank" rel="noreferrer">{t('contact.email.send')}</a>
          </article>
          {<article className="contact__option">
            <RiLinkedinBoxFill className='contact__option-icon'/>
            <h4>Linkedin</h4>
            <h5>tanguybruschi</h5>
            <a href="https://www.linkedin.com/in/tanguybruschi" target="_blank" rel="noreferrer">{t('contact.email.send')}</a>
          </article>
          }
        </div>
      </div>
    </section>
  )
}
export default Contact